import Notification from '../notification'
import * as constants from '../../utils/constants'

const PREFIX_MESSAGE_CLASS = `${constants.PREFIX_CLASS}message`
const prefixKey = `${constants.CLASS_MAIN}_message_key_`
const iconPrefix = constants.PREFIX_ICON_CLASS.replace('-', '')

let defaultDuration = 1.5
let top
let messageInstance
let name = 1
const iconTypes = {
  info: 'information',
  success: 'check-circle',
  warning: 'alert-circle',
  danger: 'close-circle',
  loading: 'loading'
}
function getMessageInstance(options) {
  messageInstance =
    messageInstance ||
    Notification.newInstance({
      prefixCls: PREFIX_MESSAGE_CLASS,
      styles: {
        top: `${top}px`
      },
      className: options.className
    })
  return messageInstance
}
function notice(type, options) {
  const onClose = options.onClose || function() {}
  const duration =
    options.duration === 0 ? 0 : options.duration || defaultDuration
  const content = options.content || ''
  const className = options.className || ''
  // const render = options.render
  const closable = options.closable || false
  const iconType = iconTypes[type]
  // if loading
  const loadCls =
    type === 'loading' ? ` ${constants.PREFIX_CLASS}ani-loop` : ''
  // 实例化一个notification对象
  let instance = getMessageInstance({ className: className })
  instance.notice({
    name: `${prefixKey}${name}`,
    duration: duration,
    styles: {},
    transitionName: 'move-up',
    content: `
          <div class="${PREFIX_MESSAGE_CLASS}-custom-content ${PREFIX_MESSAGE_CLASS}-${type}">
              <i class="${iconPrefix} ${iconPrefix}-icon ${constants.PREFIX_ICON_CLASS}${iconType}${loadCls}"></i>
              <span>${content}</span>
          </div>
        `,
    onClose: onClose,
    closable
  })
  // 用于手动消除
  return (function() {
    let target = name++
    return function() {
      instance.remove(`${prefixKey}${target}`)
    }
  })()
}

function compatible(content, type, duration, onClose, className) {
  let options
  if (Object.prototype.toString.call(content) === '[object Object]') {
    options = content
  } else {
    options = {
      content,
      onClose,
      duration,
      className
    }
  }
  return notice(type, options)
}

let TMessage = {
  info(content, duration, onClose, className) {
    return compatible(content, 'info', duration, onClose, className)
  },
  success(content, duration, onClose, className) {
    return compatible(content, 'success', duration, onClose, className)
  },
  warning(content, duration, onClose, className) {
    return compatible(content, 'warning', duration, onClose, className)
  },
  danger(content, duration, onClose, className) {
    return compatible(content, 'danger', duration, onClose, className)
  },
  loading(content, duration, onClose, className) {
    return compatible(content, 'loading', duration, onClose, className)
  },
  config(options) {
    if (options.top) {
      top = options.top
    }
    if (options.duration) {
      defaultDuration = options.duration
    }
  },
  destroy() {
    // 在销毁时判断是否有notification对象，有则获取，没有则创建一个空的notification对象
    let instance = getMessageInstance()
    messageInstance = null
    instance.destroy()
  }
}

TMessage.install = Vue => {
  Vue.prototype.$Message = TMessage
  Vue.Message = TMessage
}

export default TMessage



// WEBPACK FOOTER //
// ./src/module/message/index.js